import { useEffect, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';

export type MediaQuery = 'sm' | 'md' | 'lg' | 'xl';

export const useMedia = (query: MediaQuery): boolean => {
  const mediaQueries: Record<MediaQuery, string> = {
    sm: '(max-width: 640px)',
    md: '(min-width: 641px) and (max-width: 768px)',
    lg: '(min-width: 769px) and (max-width: 1024px)',
    xl: '(min-width: 1025px)',
  };

  const [isMatch, setIsMatch] = useState<boolean>(false);

  const mediaQuery = mediaQueries[query];

  const isMediaQueryMatched = useMediaQuery(mediaQuery);

  useEffect(() => {
    setIsMatch(isMediaQueryMatched);
  }, [isMediaQueryMatched]);

  return isMatch;
};
